import React, {memo, useEffect} from 'react';

import {SearchSummaryFields} from '../SearchSummaryFields/SearchSummaryFields';
import {SearchDetailsModal} from '../SearchDetailsModal/SearchDetailsModal';
import {SearchDetailsFields} from '../SearchDetailsFields/SearchDetailsFields';

import {useComponent} from './hooks/useComponent';

import {useTrackingContext} from '../../hooks/useTrackingContext';
import {triggerSearchFormPresentedEdapEvent} from '../../utils/edap';

import './SearchForm.less';

import '../SearchFields/SearchFields.less';
import '../SearchField/SearchField.less';
import '../SearchInputField/SearchInputField.less';
import '../SearchButtonField/SearchButtonField.less';
import '../SearchModal/SearchModal.less';

const SearchForm = memo(function SearchForm(props) {
    const {
        className,
        showSummary,
        onSubmit
    } = useComponent(props);


    const trackingContext = useTrackingContext();

    const {dataForSearchFormPresentedEvent} = props;
    const {guestsValues, datesValues, destinationValues} = dataForSearchFormPresentedEvent;

    useEffect(() => {
        triggerSearchFormPresentedEdapEvent(trackingContext, guestsValues, datesValues, destinationValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <form className={className} onSubmit={onSubmit}>
            {showSummary ? (
                <>
                    <SearchSummaryFields/>
                    <SearchDetailsModal/>
                </>
            ) : (
                <SearchDetailsFields/>
            )}
        </form>
    );
});

SearchForm.whyDidYouRender = true;

export default SearchForm;
export {SearchForm};
